import { supabase } from '../../supabase';

/**
 * Estimate LINE ITEMS CRUD (estimate_items table) — extracted out of
 * estimateService.js (2026-09-24, 500-line cap: adding the permanent-delete
 * ordering fix pushed that file past the cap). Re-exported from
 * estimateService.js so every existing `from '../../services/estimateService'`
 * import keeps working unchanged.
 *
 * No writeAuditEvent call sites here — estimate_items has no audit trail of
 * its own (item-level edits are folded into the parent estimate's
 * `estimate:edited` / status-transition rows), so this file is orthogonal to
 * the audit-emission static scanners (auditEmitterScan.js /
 * auditSingleEmissionScan.js) that estimateService.js's other helpers feed.
 */
export const getEstimateItems = async (estimateId, tenantId) => {
  if (!tenantId) return { data: null, error: new Error('tenantId is required') };
  const { data, error } = await supabase
    .from('estimate_items')
    .select('*')
    .eq('estimate_id', estimateId)
    .eq('tenant_id', tenantId)
    .order('sort_order', { ascending: true });
  return { data, error };
};

export const saveEstimateItems = async (estimateId, items, tenantId) => {
  if (!tenantId) return { data: null, error: new Error('tenantId is required') };
  const { error: deleteError } = await supabase
    .from('estimate_items')
    .delete()
    .eq('estimate_id', estimateId)
    .eq('tenant_id', tenantId);
  if (deleteError) return { data: null, error: deleteError };
  if (!items || items.length === 0) return { data: [], error: null };
  const rows = items.map(({ item_name, description, quantity, unit_price, line_total, sort_order, category, is_optional }) => ({
    item_name, description, quantity, unit_price, line_total, sort_order, category, is_optional,
    estimate_id: estimateId,
    tenant_id: tenantId,
  }));
  const { data, error } = await supabase.from('estimate_items').insert(rows).select();
  return { data, error };
};
